import React from 'react'
import PropTypes from 'prop-types'
import { withTranslator } from '../HOCComponents/withTranslator'
import { UIStyles, surfaces } from '../../theme'
import styled from 'styled-components'
import { advancedSearch } from '../../constants'
import { find, isEmpty } from 'lodash'
import moment from 'moment'
import { StyledTooltip } from '../UIComponents/StyledTooltip'

const { PLANTATION_RANGE_FILTER } = advancedSearch
const StyledDivFilter = styled.div`
  cursor: pointer;
  transition: 0.5s ease-in-out;
  position: relative;
  text-align: center;
  height: auto;
  width: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 13px;
  background-color: ${props => props.selected && UIStyles.deepblueColor3};
  box-shadow: ${props => (props.selected ? `inset 0 -3px 0 ${UIStyles.mintColor}` : 'none')};
  &:hover {
    background: ${UIStyles.whiteTransparent01};
  }
`

// Clears the active filter: neutral at rest, red only when the pointer is on it.
const StyledDeleteAdvancedFilter = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 50%;
  background: ${UIStyles.whiteTransparent015};
  color: ${UIStyles.whiteColor};
  font-weight: 100;
  padding: 5px 5px 3px;
  font-size: 6px;
  text-align: center;
  &:hover {
    background: ${UIStyles.redColor};
  }
`
const StyledIconClose = styled.i`
  font-size: 8px;
`

const StyledIcon = styled.i`
  color: ${UIStyles.mintColor};
  font-size: 2rem;
`

const StyledDivAdvFilterList = styled.div`
  position: absolute;
  width: 200px;
  border: 1px solid ${UIStyles.mintBorder};
  background: ${UIStyles.deepblueColor3};
  border-radius: 12px;
  box-shadow: ${surfaces.floatingPanelShadow};
  display: ${props => (props.isOpen ? `block` : `none`)};
  top: 40px;
  left: -25px;
  z-index: 5;
  &:before {
    position: absolute;
    content: '';
    width: 14px;
    height: 14px;
    top: -8px;
    left: 34px;
    z-index: 1;
    background: ${UIStyles.deepblueColor3};
    border-top: 1px solid ${UIStyles.mintBorder};
    border-left: 1px solid ${UIStyles.mintBorder};
    transform: rotate(45deg);
  }
`

const StyledUlFilterList = styled.ul`
  overflow-y: auto;
  max-height: 400px;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
  border-radius: 11px;
`

const StyledLiFilterName = styled.li`
  padding: 10px;
  font-size: 12px;
  letter-spacing: 0.5px;
  color: ${UIStyles.whiteTransparent08};
  &:hover {
    background: ${UIStyles.whiteTransparent01};
    color: ${UIStyles.whiteColor};
  }
`

const AdvancedFilter = ({ searchOptions, selectedFilterIds, filters, filterType, name, icon, isOpen, t, openFilterType, onSelect, onReset, testId }) => {
  const isYearFilterType = filterType === PLANTATION_RANGE_FILTER
  const isFilterEmpty = isYearFilterType ? !filters[filterType].from : isEmpty(filters[filterType])
  const filterOptions = searchOptions[filterType]
  const selectedOptionFilter = find(filterOptions, { id: selectedFilterIds[0] })
  const toolTipTitleBySelectedFilter = isFilterEmpty
    ? t(name)
    : isYearFilterType
    ? moment(filters[filterType].from, 'YYYY/MM/DD').format('DD/MM/YYYY') + ' - ' + moment(filters[filterType].to, 'YYYY/MM/DD').format('DD/MM/YYYY')
    : t(selectedOptionFilter.name)

  if (searchOptions.cutNumber) {
    searchOptions.cutNumber.sort((a, b) => parseInt(a.id) - parseInt(b.id))
  }

  return (
    <StyledDivFilter selected={!isFilterEmpty}>
      {!isFilterEmpty && (
        <StyledDeleteAdvancedFilter onClick={() => onReset()}>
          <StyledIconClose className="ion-close" />
        </StyledDeleteAdvancedFilter>
      )}
      <div onClick={() => openFilterType(filterType)}>
        <StyledTooltip
          // options
          title={isFilterEmpty ? t(name) : t(toolTipTitleBySelectedFilter)}
          placement="top"
          key={t(name)}
        >
          <StyledIcon className={icon} data-testid={testId} />
        </StyledTooltip>
        {!isYearFilterType && (
          <StyledDivAdvFilterList isOpen={isOpen}>
            <StyledUlFilterList>
              {searchOptions[filterType].map((filter, key) => (
                <StyledLiFilterName key={key} onClick={() => onSelect(filter.id)}>
                  {t(filter.name)}
                </StyledLiFilterName>
              ))}
            </StyledUlFilterList>
          </StyledDivAdvFilterList>
        )}
      </div>
    </StyledDivFilter>
  )
}

AdvancedFilter.propTypes = {
  filterType: PropTypes.string,
  icon: PropTypes.string,
  isOpen: PropTypes.bool,
  name: PropTypes.string,
  selectFilter: PropTypes.func,
  selected: PropTypes.object,
  openFilterType: PropTypes.func,
  testId: PropTypes.string,
  t: PropTypes.func,
  filters: PropTypes.object,
  searchOptions: PropTypes.object,
  selectedFilterIds: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
}

export default withTranslator(AdvancedFilter)
